import {openWindow} from "../http/WindowOpener";
import common from "@well-b/well-b-shared";
import {getThemeByOrigin} from "../utils.js";
import {Config, ConfigProps} from "../Config.js";
import {disableFooterSupportContactBySystemId} from "../consts.js";

export class ContactPhone {
    static whatsAppLink(phoneNumber = null, message = null) {
        const number = phoneNumber
            ? phoneNumber
            : ContactPhone.phoneNumber() ?? ContactPhone.defaultPhoneNumberBySystemId();
        const cleanNumber = number?.replace(/[^\d]/g, "");

        const params = new URLSearchParams();

        if (message) {
            params.append("text", message);
        }

        params.append("phone", cleanNumber);

        return `https://api.whatsapp.com/send?${params.toString()}`;
    }

    static openWhatsApp(phoneNumber = null) {
        openWindow(ContactPhone.whatsAppLink(phoneNumber), "_blank", true);
    }

    static openPhone(phoneNumber = null) {
        const number = phoneNumber
            ? phoneNumber
            : ContactPhone.phoneNumber() ?? ContactPhone.defaultPhoneNumberBySystemId();
        window.location.href = `tel:${number}`;
    }

    static openEmail(email = null) {
        window.location.href = `mailto:${email}`;
    }

    static phoneNumber() {
        const systemIdToSupportPhoneNumber = Config.envJson(ConfigProps.APP_CONTACT_DETAILS_BY_SYSTEM_ID);
        const systemId = getThemeByOrigin(window.location.origin);

        if (disableFooterSupportContactBySystemId[systemId]) {
            return;
        }

        return systemIdToSupportPhoneNumber[systemId.toLowerCase()]?.whatsapp;
    }

    static phoneNumberBySystemId(systemId) {
        const systemIdToSupportPhoneNumber = Config.envJson(ConfigProps.APP_CONTACT_DETAILS_BY_SYSTEM_ID);
        const selectedSystemId = systemId || common.themeNames.wellB;

        if (disableFooterSupportContactBySystemId[selectedSystemId]) {
            return;
        }

        return (
            systemIdToSupportPhoneNumber[selectedSystemId.toLowerCase()]?.whatsapp ||
            Config.env(ConfigProps.SUPPORT_PHONE_NUMBER)
        );
    }

    static prettyPhoneNumber(phoneNumber = null) {
        phoneNumber = (
            phoneNumber ||
            ContactPhone.phoneNumber() ||
            ContactPhone.defaultPhoneNumberBySystemId()
        )?.replace("+", "");
        return `+${phoneNumber?.match(/.{1,3}/g)?.join(" ")}`;
    }

    static defaultPhoneNumberBySystemId() {
        const systemIdToDefaultSupportPhoneNumber = Config.envJson(
            ConfigProps.SYSTEM_ID_TO_DEFAULT_SUPPORT_PHONE_NUMBER
        );
        const systemId = getThemeByOrigin(window.location.origin);

        return systemIdToDefaultSupportPhoneNumber[systemId.toLowerCase()];
    }
}
